export const BlockchainBannerContentArabic = {
    mainHeading: "تطوير البلوك تشين",
    greenHeading: "الخدمات",
    subHeading: "ادفع عملك إلى الأمام من خلال حلول البلوك تشين الآمنة والمصممة خصيصًا.",
    content:
        "استفد من النظام البيئي اللامركزي من خلال خدمات تطوير البلوك تشين لدينا وضع عملك في مكانة مستقبلية.",
    btnText2: "هيا بنا نبدأ",
};

export const BlockchainDevelopmentServicesDataArabic = {

    mainHeading: "مجموعتنا الواسعة من خدمات تطوير البلوك تشين",
    sectionDescription: "أطلق العنان لإمكانيات البلوك تشين من خلال حلول آمنة وقابلة للتطوير ومبتكرة مصممة لتلبية احتياجات عملك. من العقود الذكية إلى التطبيقات اللامركزية، نحن نمكّن الشركات من تعزيز الشفافية والكفاءة والأمان. سواء كنت تحتاج إلى استشارات أو تطوير بلوك تشين مخصص أو حلول على مستوى المؤسسات، تضمن خبرتنا التكامل السلس والأداء الأمثل.",
    servicesCards: [
        {
            id: "Tab1",
            label: "تطوير SaaS المدعوم بالبلوك تشين",
            content:
                "استفد من تقنية البلوك تشين لبناء تطبيقات SaaS آمنة وقابلة للتطوير ولامركزية. تضمن حلولنا التكامل السلس للعقود الذكية، والمعاملات الشفافة، وتعزيز سلامة البيانات. من خلال لامركزية منصات SaaS، يمكن للشركات تحقيق أمان أكبر وأتمتة وكفاءة. نهجنا القائم على البلوك تشين يزيل مخاطر الطرف الثالث، ويقلل التكاليف التشغيلية، ويضمن الامتثال لمعايير الصناعة. سواء كنت بحاجة إلى حل SaaS جديد أو ترغب في تحسين حل موجود، فإننا نقدم تطبيقات SaaS مخصصة ومدعومة بالبلوك تشين تدفع الابتكار والنمو.",
            btnText: "دعنا نناقش",
            btnLink: "#",
            imgs: [
                {
                    img: "/images/services-icons/blockchain-development/atherium.png",
                },
                {
                    img: "/images/services-icons/blockchain-development/solidity.png",
                },
                {
                    img: "/images/services-icons/blockchain-development/logo-foundry-formerly-black.png",
                },
                {
                    img: "/images/services-icons/blockchain-development/node.png",
                },
            ],
        },
        {
            id: "Tab2",
            label: "بوابات الويب اللامركزية",
            content:
                "قم بتطوير بوابات ويب لامركزية آمنة وشفافة للغاية ومدعومة بالبلوك تشين. توفر حلولنا للشركات سجلات غير قابلة للتغيير، وأمانًا معززًا، وسير عمل آليًا، مما يلغي الاعتماد على السلطات المركزية. من خلال الاستفادة من العقود الذكية ودفاتر الأستاذ الموزعة، نضمن سلامة البيانات، وتحسين التحكم في الوصول، والتفاعلات الرقمية المقاومة للتلاعب. تعد بوابات الويب اللامركزية مثالية للصناعات التي تتطلب معاملات آمنة، حيث تعمل على تعزيز خصوصية المستخدم والكفاءة التشغيلية مع ضمان الثقة والشفافية في العمليات التجارية.",
            btnText: "دعنا نناقش",
            btnLink: "#",
            imgs: [
                {
                    img: "/images/services-icons/blockchain-development/atherium.png",
                },
                {
                    img: "/images/services-icons/blockchain-development/solidity.png",
                },
                {
                    img: "/images/services-icons/blockchain-development/logo-foundry-formerly-black.png",
                },
                {
                    img: "/images/services-icons/blockchain-development/node.png",
                },
            ],
        },
        {
            id: "Tab3",
            label: "تطوير الواجهة الخلفية المدعوم بالبلوك تشين",
            content:
                "قم ببناء نظام خلفي قوي ولامركزي يعزز أمن البيانات وشفافيتها. تزيل حلولنا الخلفية المدعومة بالبلوك تشين نقاط الفشل الفردية، مما يضمن عمليات سلسة، وتوفرًا عاليًا، وحماية ضد التهديدات السيبرانية. من خلال تقنية دفتر الأستاذ الموزعة، نمكّن المعاملات الآمنة، والعمليات الآلية عبر العقود الذكية، ومزامنة البيانات في الوقت الفعلي. سواء للخدمات المالية، أو إدارة سلسلة التوريد، أو تطبيقات المؤسسات، توفر حلولنا الخلفية أساسًا قويًا للتحول الرقمي المدفوع بالبلوك تشين.",
            btnText: "دعنا نناقش",
            btnLink: "#",
            imgs: [
                {
                    img: "/images/services-icons/blockchain-development/atherium.png",
                },
                {
                    img: "/images/services-icons/blockchain-development/solidity.png",
                },
                {
                    img: "/images/services-icons/blockchain-development/logo-foundry-formerly-black.png",
                },
                {
                    img: "/images/services-icons/blockchain-development/node.png",
                },
            ],
        },
        {
            id: "Tab4",
            label: "تطوير الواجهة الأمامية المدعوم بالبلوك تشين",
            content:
                "قم بإنشاء واجهات أمامية بديهية وآمنة ولامركزية تتفاعل بسلاسة مع الواجهات الخلفية القائمة على البلوك تشين. يضمن تطوير الواجهة الأمامية المدعوم بالبلوك تشين تفاعلات شفافة للمستخدم، وأمانًا تشفيريًا، ومعاملات بيانات مقاومة للتلاعب. ندمج تقنيات Web3، ومصادقة الهوية اللامركزية، وتنفيذ العقود الذكية بسلاسة، مما يضمن تجارب مستخدم عالية الأداء. من خلال الجمع بين خبرة UX/UI وأمان البلوك تشين، نقدم واجهات أمامية قابلة للتطوير ومتجاوبة ومقاومة للمستقبل للتطبيقات اللامركزية، ومنصات المؤسسات، والحلول الرقمية.",
            btnText: "دعنا نناقش",
            btnLink: "#",
            imgs: [
                {
                    img: "/images/services-icons/blockchain-development/atherium.png",
                },
                {
                    img: "/images/services-icons/blockchain-development/solidity.png",
                },
                {
                    img: "/images/services-icons/blockchain-development/logo-foundry-formerly-black.png",
                },
                {
                    img: "/images/services-icons/blockchain-development/node.png",
                },
            ],
        },
        {
            id: "Tab5",
            label: "خدمات استشارات البلوك تشين",
            content:
                "احصل على إرشادات الخبراء بشأن تطبيق البلوك تشين واستراتيجياته وأفضل الممارسات المصممة خصيصًا لاحتياجات عملك. تساعد خدماتنا الاستشارية المؤسسات على تقييم جدوى البلوك تشين، واختيار الأطر الصحيحة، وتطوير حلول آمنة وقابلة للتطوير. نقوم بتحليل حالات الاستخدام، وتحديد مخاطر الأمان، وتقديم رؤى متعمقة حول دمج البلوك تشين مع البنى التحتية الحالية. سواء كنت تحتاج إلى مساعدة في العقود الذكية، أو ترميز الأصول، أو حلول التمويل اللامركزي (DeFi)، يضمن مستشارونا اعتمادًا سلسًا وناجحًا للبلوك تشين.",
            btnText: "دعنا نناقش",
            btnLink: "#",
            imgs: [
                {
                    img: "/images/services-icons/blockchain-development/atherium.png",
                },
                {
                    img: "/images/services-icons/blockchain-development/solidity.png",
                },
                {
                    img: "/images/services-icons/blockchain-development/logo-foundry-formerly-black.png",
                },
                {
                    img: "/images/services-icons/blockchain-development/node.png",
                },
            ],
        },
        {
            id: "Tab6",
            label: "حلول بلوك تشين للمؤسسات",
            content:
                "قم بتمكين مؤسستك من خلال حلول بلوك تشين قابلة للتطوير وآمنة وعلى مستوى المؤسسات ومصممة خصيصًا لتلبية احتياجات صناعية محددة. تتيح خدمات بلوك تشين للمؤسسات لدينا مشاركة البيانات الآمنة، وأتمتة العمليات، ومنع الاحتيال مع ضمان الامتثال للمعايير التنظيمية. من خلال تطبيق شبكات بلوك تشين مسموح بها أو مختلطة، نساعد الشركات على تعزيز الشفافية وتبسيط العمليات وتحسين الأمان. من التمويل والرعاية الصحية إلى سلسلة التوريد والحوكمة، تدفع حلول بلوك تشين المخصصة للمؤسسات التحول الرقمي والابتكار.",
            btnText: "دعنا نناقش",
            btnLink: "#",
            imgs: [
                {
                    img: "/images/services-icons/blockchain-development/atherium.png",
                },
                {
                    img: "/images/services-icons/blockchain-development/solidity.png",
                },
                {
                    img: "/images/services-icons/blockchain-development/logo-foundry-formerly-black.png",
                },
                {
                    img: "/images/services-icons/blockchain-development/node.png",
                },
            ],
        },
        {
            id: "Tab7",
            label: "تطوير CMS بلوك تشين بلا رأس (Headless Blockchain CMS)",
            content:
                "قم بتطبيق نظام إدارة محتوى لامركزي (CMS) مدعوم بالبلوك تشين لتسليم المحتوى بشكل آمن وفعال. تضمن حلول CMS بلوك تشين بلا رأس لدينا عدم قابلية البيانات للتغيير، وأصالة المحتوى، وأمانًا معززًا. من خلال فصل الواجهة الخلفية عن الواجهة الأمامية، نمكّن التوزيع السلس للمحتوى عبر منصات متعددة مع الاستفادة من طبيعة البلوك تشين التي لا تتطلب ثقة ومقاومة للتلاعب. سواء للوسائط، أو النشر، أو التجارة الإلكترونية، يضمن نظام إدارة المحتوى المدعوم بالبلوك تشين الشفافية، ويزيل التعديلات غير المصرح بها، ويعزز إدارة الأصول الرقمية.",
            btnText: "دعنا نناقش",
            btnLink: "#",
            imgs: [
                {
                    img: "/images/services-icons/blockchain-development/atherium.png",
                },
                {
                    img: "/images/services-icons/blockchain-development/solidity.png",
                },
                {
                    img: "/images/services-icons/blockchain-development/logo-foundry-formerly-black.png",
                },
                {
                    img: "/images/services-icons/blockchain-development/node.png",
                },
            ],
        },
    ]
}

export const BlockchainProcessStepsDataArabic = {
    mainHeading: "الفوائد المؤثرة لتقنية",
    greenHeading: "البلوك تشين لعملك",
    sectionDescription: "تعمل تقنية البلوك تشين على تحويل عملك من خلال حلول لامركزية وآمنة وشفافة. نساعدك على تسخيرها لدفع النمو والبقاء تنافسيًا.",
    stepsData: [
        {
            stepNumber: "01",
            title: "أمان معزز",
            content:
                "يضمن الهيكل اللامركزي والتشفير في البلوك تشين أمان البيانات والمعاملات.",
            icon: "/images/SECURE.png",
            bgClass: "icon-change",
        },
        {
            stepNumber: "02",
            title: "زيادة الشفافية",
            content:
                "يتم تسجيل جميع المعاملات في دفتر أستاذ موزع ومرئي يمكن للمستخدمين المصرح لهم الوصول إليه.",
            icon: "/images/transparency.png",
            bgClass: "",
        },
        {
            stepNumber: "03",
            title: "تحسين الكفاءة",
            content:
                "العمليات الآلية تقلل الوسطاء، مما يبسط العمليات.",
            icon: "/images/disruptive-SOLUTIONS.png",
            bgClass: "",
        },
        {
            stepNumber: "04",
            title: "اللامركزية",
            content:
                "يتم توزيع التحكم عبر الشبكة، مما يعزز سلامة البيانات والمرونة.",
            icon: "/images/SupplyChain.png",
            bgClass: "icon-change",
        },
        {
            stepNumber: "05",
            title: "توفير التكاليف",
            content:
                "الاعتماد الأقل على الأطراف الثالثة يقلل النفقات، مما يسمح بإعادة الاستثمار في النمو.",
            icon: "/images/FULL-ownership.png",
            bgClass: "",
        },
        {
            stepNumber: "06",
            title: "الوصول إلى البيانات في الوقت الفعلي",
            content:
                "يسمح الوصول إلى البيانات في الوقت الفعلي باتخاذ قرارات أسرع وأكثر استجابة.",
            icon: "/images/req-icon3.svg",
            bgClass: "",
        },
        {
            stepNumber: "07",
            title: "معاملات لا تتطلب ثقة",
            content:
                "تجري الأطراف المعاملات دون الحاجة إلى الثقة؛ تضمن البلوك تشين استيفاء الشروط.",
            icon: "/images/FLEXIBILITY.png",
            bgClass: "icon-change",
        },
        {
            stepNumber: "08",
            title: "سجلات غير قابلة للتغيير",
            content:
                "السجلات دائمة ومقاومة للتلاعب، وهي مثالية للتدقيق والامتثال.",
            icon: "/images/transpaent-insights.png",
            bgClass: "",
        },
        {
            stepNumber: "09",
            title: "الوصول العالمي",
            content:
                "تسهل البلوك تشين المعاملات عبر الحدود، مما يوسع نطاق الأعمال.",
            icon: "/images/time-zone.png",
            bgClass: "",
        },
    ]
}

export const BlockchainWhoWeServeDataArabic = {
    mainHeading: "من نخدم",
    sectionDescription: "تعيد تقنية البلوك تشين تشكيل الصناعات، مقدمة الأمان والشفافية والكفاءة بشكل لم يسبق له مثيل. تلبي خدمات تطوير البلوك تشين لدينا الشركات التي تبحث عن حلول بلوك تشين مخصصة، ومعاملات آمنة، وتطبيقات لا مركزية (DApps) لدفع الابتكار والنمو.",
    cardsData: [
        {
            icon: "/images/servie-icon/startups.svg",
            title: "الشركات الناشئة التي تتبنى البلوك تشين",
            description:
                "يمكن للشركات الناشئة الاستفادة من البلوك تشين لإنشاء حلول مبتكرة، من بوابات الدفع الآمنة إلى سلاسل التوريد الشفافة. نساعدهم على بناء تطبيقات بلوك تشين قابلة للتطوير ومستقبلية.",
            link: "#",
            borderClass: "border-1",
        },
        {
            icon: "/images/servie-icon/company.png",
            title: "الشركات الكبرى التي تتبنى حلول البلوك تشين",
            description:
                "تقوم الشركات الكبرى بدمج البلوك تشين لتعزيز الأمان والكفاءة وإمكانية التتبع. تدعم حلول البلوك تشين لدينا تطبيقات على مستوى المؤسسات وتنفيذ العقود الذكية بسلاسة.",
            link: "#",
            borderClass: "border-2",
        },
        {
            icon: "/images/servie-icon/industries.svg",
            title: "ثورة التكنولوجيا المالية والبنوك",
            description:
                "تستفيد الصناعة المالية من البلوك تشين من خلال المعاملات الآمنة، ومنع الاحتيال، وحلول التمويل اللامركزي (DeFi). تضمن خبرتنا الامتثال والتطبيقات المالية عالية الأداء.",
            link: "#",
            borderClass: "border-3",
        },
    ]
}

export const BlockchainWhyChooseBitsclanDataArabic = {
    mainHeading: "لماذا تختار بيتسكلان شريكك في تطوير البلوك تشين؟",
    sectionDescription: "البلوك تشين ليست مجرد اتجاه - إنها تقنية تحويلية. في بيتسكلان، نقدم حلول بلوك تشين آمنة وقابلة للتطوير ومبتكرة مصممة للارتقاء بعملك. سواء كنت بحاجة إلى عقود ذكية، أو تطبيقات لامركزية (DApps)، أو تكامل بلوك تشين للمؤسسات، فإن خبرتنا تضمن أمانًا وشفافية وكفاءة تشغيلية معززة.",
    cardsData: [
        {
            id: "Tab1",
            label: "الجودة لأنها تهم",
            content:
                "في بيتسكلان، الجودة ليست مجرد أولوية - إنها أساس كل ما نقوم به. يتم بناء حلول البلوك تشين الخاصة بنا بدقة، مما يضمن أداءً عاليًا وأمانًا وقابلية للتوسع.",
            btnText: "تواصل مع فريقنا",
            btnLink: "#",
        },
        {
            id: "Tab2",
            label: "أفضل المواهب من نوعها",
            content:
                "يتكون فريقنا من مطوري بلوك تشين وخبراء أمن واستراتيجيين من الطراز الأول، مما يجلب خبرة عميقة وتفكيرًا مبتكرًا لكل مشروع.",
            btnText: "تواصل مع فريقنا",
            btnLink: "#",
        },
        {
            id: "Tab3",
            label: "توافق المناطق الزمنية",
            content:
                "نحن نعمل عبر المناطق الزمنية العالمية، مما يضمن تعاونًا سلسًا واتصالات في الوقت الفعلي لتقدم المشروع دون انقطاع.",
            btnText: "تواصل مع فريقنا",
            btnLink: "#",
        },
        {
            id: "Tab6",
            label: "إجراءات أمنية متطورة",
            content:
                "الأمان في صميم حلولنا. نحن نطبق تشفيرًا متقدمًا، وعمليات تدقيق صارمة، وأفضل بروتوكولات الأمان في فئتها لحماية نظامك البيئي للبلوك تشين.",
            btnText: "تواصل مع فريقنا",
            btnLink: "#",
        },
        {
            id: "Tab7",
            label: "تكامل سلس للبلوك تشين",
            content:
                "نحن نضمن اعتماد البلوك تشين بسهولة من خلال دمج الحلول اللامركزية مع البنية التحتية الحالية لعملك لتحقيق أقصى قدر من الكفاءة.",
            btnText: "تواصل مع فريقنا",
            btnLink: "#",
        },
    ]
}

export const BlockchainHighvaluesDataArabic = {
    mainHeading: "ميزات عالية القيمة لحلول البلوك تشين المتقدمة",
    sectionDescription: "أطلق العنان لقوة البلوك تشين من خلال حلول آمنة وقابلة للتطوير وفعالة. من العقود الذكية إلى التطبيقات اللامركزية (DApps)، تضمن خدمات تطوير البلوك تشين لدينا الشفافية والأتمتة والأمان المعزز لعملك. نركز على التكامل السلس والأداء العالي وحلول البلوك تشين المبتكرة لمساعدتك على البقاء في المقدمة في المشهد اللامركزي. سواء كنت تؤمن المعاملات أو تبني تطبيقات على مستوى المؤسسات، فإن خبرتنا تضمن الموثوقية والثقة.",
    buttonText: "استشر نطاق المشروع",
    highValueCardData: [
        {
            image: "data-anylytics-icon1.svg",
            text: "حلول تحليلات البيانات المخصصة",
        },
        {
            image: "data-anylytics-icon2.svg",
            text: "رؤى البيانات في الوقت الفعلي",
        },
        {
            image: "data-anylytics-icon3.svg",
            text: "تكامل التحليلات المتقدمة",
        },
        {
            image: "data-anylytics-icon4.svg",
            text: "حلول بيانات قابلة للتطوير",
        },
        {
            image: "data-anylytics-icon5.svg",
            text: "لوحات معلومات موجهة للمستخدم",
        },
        {
            image: "data-anylytics-icon6.svg",
            text: "معالجة آمنة للبيانات",
        },
        {
            image: "data-anylytics-icon7.svg",
            text: "تحليلات البيانات الضخمة",
        },
        {
            image: "data-anylytics-icon8.svg",
            text: "اتخاذ القرارات المستندة إلى البيانات",
        },
        {
            image: "data-anylytics-icon9.svg",
            text: "تحليلات البيانات المؤتمتة",
        },
        {
            image: "data-anylytics-icon10.svg",
            text: "صيانة البيانات المستمرة",
        },
    ]
}

export const BlockchainRoadMapDataArabic = {
    heading: "خارطة طريقنا المثبتة لتطوير بلوك تشين ناجح",
    description:
        "نحن نتبع منهجًا منظمًا لضمان أن حلول البلوك تشين الخاصة بك آمنة وقابلة للتطوير وفعالة. من التخطيط الأولي إلى النشر، تضمن عملية تطوير البلوك تشين المخصصة لدينا تنفيذًا سلسًا، وتكامل العقود الذكية، وموثوقية طويلة الأجل. إليك كيف نقوم بذلك:",
    roadMapHeading: [],
    roadMapsteps: [
        "نقوم بتحليل أهدافك، وتحديد أفضل استراتيجية للبلوك تشين، ووضع خارطة طريق واضحة لضمان التنفيذ السلس وقابلية التوسع في المستقبل.",
        "نقوم بإنشاء إثبات للمفهوم لاختبار الجدوى والأمان وبنية النظام اللامركزي، مما يضمن التوافق مع احتياجات عملك.",
        "من العقود الذكية إلى التطبيقات اللامركزية، نقوم بتطوير واختبار حلول البلوك تشين الخاصة بك بدقة للتأكد من الأداء والأمان والكفاءة.",
        "نقوم بنشر حل تطوير البلوك تشين المخصص الخاص بك ونوفر دعمًا مستمرًا، مما يضمن التحديثات وتصحيحات الأمان والتشغيل السلس.",
    ],
};

export const BlockchainCoverTheStackArabic = {
    mainHeading: "حزمة التقنيات التي تدعم تطوير تطبيقاتنا المحمولة",
    sectionDescription:
        "في Bitsclan، لا نقوم فقط ببناء تطبيقات محمولة، بل نُبدع تجارب رقمية مدعومة بأحدث التقنيات في هذا المجال. بفضل خبرتنا في استخدام حزمة التقنيات الرائدة، نستفيد من أحدث الأدوات والمنصات لضمان أن يكون تطبيقك المحمول ليس فقط عمليًا، بل أيضًا مهيأً للمستقبل ومحسّنًا لتقديم أفضل تجربة مستخدم.",
    defaultOpenTab: "منصات البلوك تشين",
    blockchaintabs: [
        "منصات البلوك تشين",
        "الحلول المؤسسية",
        "آليات الإجماع",
        "حلول التخزين",
    ],

    blockchaintabItems: [
        // منصات البلوك تشين
        { tab: "منصات البلوك تشين", icon: "/images/tech-stack-icons/ethereum.png", name: "Ethereum" },
        { tab: "منصات البلوك تشين", icon: "/images/tech-stack-icons/stellar.png", name: "Stellar" },
        { tab: "منصات البلوك تشين", icon: "/images/tech-stack-icons/Ripple.png", name: "Ripple" },

        // الحلول المؤسسية
        { tab: "الحلول المؤسسية", icon: "/images/tech-stack-icons/Hyperledger.png", name: "HyperLedger" },
        { tab: "الحلول المؤسسية", icon: "/images/tech-stack-icons/microsoft-icon.png", name: "Azure Blockchain" },
        { tab: "الحلول المؤسسية", icon: "/images/tech-stack-icons/download-3.png", name: "Azure Service Fabric" },

        // آليات الإجماع
        { tab: "آليات الإجماع", icon: "/images/tech-stack-icons/tendermint-logo-black.png", name: "Tendermint" },

        // حلول التخزين
        { tab: "حلول التخزين", icon: "/images/tech-stack-icons/IPFS_logo.png", name: "IPFS" },
        { tab: "حلول التخزين", icon: "/images/tech-stack-icons/Bigchaindb.png", name: "BigChainDB" }
    ]
}

export const BlockchainIndustriesHeadingArabic = {
    mainHeading: "الصناعات التي نخدمها تحليلات Blockchain"
}

export const BlockchainFaqDataArabic = {
    mainHeading: "الأسئلة الشائعة",
    sectionDescription: "توفر Bitsclan حلول بلوكتشين آمنة وقابلة للتوسع مع دعم شامل عبر مختلف المنصات والصناعات.",
    questionAnswer: [
        {
            id: "collapseOne",
            question: "ما هو تطوير البلوكتشين؟",
            answer:
                "يشير تطوير البلوكتشين إلى عملية بناء التطبيقات اللامركزية (dApps)، والعقود الذكية، وأنظمة السجلات الموزعة باستخدام تقنية البلوكتشين. وهي تُمكّن من تنفيذ معاملات رقمية آمنة وشفافة وغير قابلة للتلاعب عبر مختلف الصناعات.",
        },
        {
            id: "collapseTwo",
            question: "ما هي العقود الذكية وكيف تعمل؟",
            answer:
                "العقود الذكية هي اتفاقيات رقمية تُنفذ ذاتيًا تحتوي على قواعد محددة مكتوبة على شكل كود. تعمل على شبكات البلوكتشين وتُطبق الشروط تلقائيًا دون الحاجة إلى وسطاء، مما يضمن الثقة والشفافية والكفاءة في المعاملات.",
        },
        {
            id: "collapseThree",
            question: "ما هي منصات البلوكتشين التي تتخصصون فيها؟",
            answer:
                "في Bitsclan، نتخصص في منصات البلوكتشين الرائدة مثل Ethereum وBinance Smart Chain وHyperledger وSolana وPolygon. ونهجنا المحايد للمنصات يُمكننا من التوصية بالحل الأنسب وفقًا لاحتياجات عملك الخاصة.",
        },
        {
            id: "fourth",
            question: "ما مدى أمان تقنية البلوكتشين لتطبيقات الأعمال؟",
            answer:
                "تم تصميم البلوكتشين باستخدام خوارزميات تشفير متقدمة وهيكل لامركزي يوفر مستوى أمان عالٍ. وعند تطويره وفقًا لأفضل الممارسات، يقلل من مخاطر تسرب البيانات والاحتيال والوصول غير المصرح به، مما يجعله مثاليًا للتطبيقات الحيوية.",
        },
        {
            id: "fifth",
            question: "ما هي الصناعات التي يمكنها الاستفادة من حلول البلوكتشين؟",
            answer:
                "يمتلك البلوكتشين قدرة تحويلية في قطاعات متعددة مثل المالية، وسلاسل التوريد، والرعاية الصحية، والعقارات، واللوجستيات، والألعاب. فهو يعزز الكفاءة التشغيلية، ويضمن سلامة البيانات، ويعزز الشفافية والثقة.",
        },
        {
            id: "sixth",
            question: "هل تقدم Bitsclan خدمات تطوير بلوكتشين شاملة؟",
            answer:
                "نعم، تقدم Bitsclan خدمات تطوير بلوكتشين متكاملة بدءًا من الاستشارة الأولية وتصميم المعمارية، وصولًا إلى تطوير العقود الذكية، ونشر التطبيقات اللامركزية، والصيانة بعد الإطلاق بما يتماشى مع أهداف عملك.",
        },
        {
            id: "seventh",
            question: "ما الفرق بين البلوكتشين العام والخاص؟",
            answer:
                "البلوكتشين العام هو شبكة مفتوحة وغير مقيدة (مثل Ethereum وBitcoin) يمكن لأي شخص الانضمام إليها والتفاعل معها. أما البلوكتشين الخاص فهو نظام مُصرح به، مثالي للمؤسسات التي تتطلب وصولًا محدودًا، وخصوصية محسّنة، وتحكمًا في البيانات.",
        },
    ]
}